import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

export const MudToysTeaser = () => (
  <section className="mx-auto max-w-7xl px-6 py-24 lg:px-12 lg:py-32" data-testid="mud-toys-teaser">
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 1, ease: EASE }}
      className="grid grid-cols-1 items-center gap-10 md:grid-cols-12"
    >
      <div className="md:col-span-5">
        <div className="arch-frame mx-auto max-w-xs border border-brand-border bg-[#F4EFE6] p-3">
          <div className="arch-frame overflow-hidden">
            <img
              src="/assets/mud-toys.jpg"
              alt="Laxwedeepan mud toys — a clay elephant, bunnies and a bird"
              loading="lazy"
              data-testid="mud-toys-teaser-image"
              className="aspect-[4/5] w-full object-cover"
            />
          </div>
        </div>
      </div>
      <div className="text-center md:col-span-6 md:col-start-7 md:text-left">
        <p className="text-[11px] font-medium uppercase tracking-[0.4em] text-brand-gold">The Playful Line</p>
        <h2 className="mt-4 font-display text-4xl font-medium text-brand-ink md:text-5xl">
          Meet the <em className="italic text-brand-peach">clay friends.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-md text-base font-light leading-relaxed text-brand-ink/70 md:mx-0">
          A mustard elephant, two giggling bunnies and one very round bird —
          shaped from river clay, waiting to move into a childhood near you.
        </p>
        <Link
          to="/collection"
          data-testid="mud-toys-teaser-link"
          className="group mt-8 inline-flex items-center gap-3 rounded-full border border-brand-gold px-8 py-4 text-[11px] font-medium uppercase tracking-[0.25em] text-brand-maroon transition-colors duration-300 hover:bg-brand-gold hover:text-brand-ivory"
        >
          Meet Them All
          <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={1.5} />
        </Link>
      </div>
    </motion.div>
  </section>
);
